module.exports = __webpack_public_path__ + "media/react/assets/GoalIcon-0bde4a3bb6ce028f41501e90dc9486ce.svg";